let config = sessionStorage.getItem('config')
let selectedParking = sessionStorage.getItem('selectedParking')

let api = null
let discountApi = null
let parkingApi = null
let reverseApi = null

if (config) {
    let c = JSON.parse(config)
    api = (selectedParking ? selectedParking : (c.parkings ? c.parkings[0].endpoint : c.api))
    discountApi = c.discountApi || null
    parkingApi = c.parkingApi || null
    reverseApi = c.reverseApi || null
}

export const apiRoute = api
export const discountApiRoute = discountApi
export const parkingApiRoute = parkingApi
export const reverseApiRoute = reverseApi
